import React from 'react';
import { RichText } from '../ui/RichText';
import { slugify } from '../../utils/text';
import type { ArticleBlock } from '../../types/content';

// Renders article blocks with editorial reading typography. The first paragraph is set as a larger lede.
export function ArticleBody({
  blocks,
  isStart = false
}: {
  blocks: ArticleBlock[];
  isStart?: boolean;
}) {
  return <>
      {blocks.map((block, index) => {
      if (block.type === 'h2') {
        return <h2 key={index} id={slugify(block.text)} className="mb-5 mt-14 scroll-mt-28 type-h3 text-ink first:mt-0" data-id="element-81" data-mp="1o0t4gm3j6td1">
              {block.text}
            </h2>;
      }
      if (block.type === 'list') {
        return <ul key={index} className="mb-8 space-y-3 pl-1" data-id="element-82" data-mp="1xrnyicn0qx91">
              {block.items.map(item => <li key={item} className="flex gap-4 type-body leading-[1.75] text-ink" data-id="element-83" data-mp="10agyhgruj6p3">
                  <span className="mt-[0.7em] h-1.5 w-1.5 shrink-0 rounded-full bg-brand" aria-hidden="true" data-id="element-84" data-mp="159a28hhbzjc2" />
                  <span data-id="element-85" data-mp="pqjvxdpysk0r">
                    <RichText text={item} data-id="element-86" data-mp="ptxtm8noo51v" />
                  </span>
                </li>)}
            </ul>;
      }
      const isLede = isStart && index === 0;
      return <p key={index} className={isLede ? 'mb-10 type-card-title font-normal leading-[1.6] text-ink' : 'mb-6 type-body leading-[1.8] text-ink'} data-id="element-87" data-mp="gx6qjcaprpxs" data-mpi={index}>
            <RichText text={block.text} data-id="element-88" data-mp="72etc9l1n53j" />
          </p>;
    })}
    </>;
}